// extracted by mini-css-extract-plugin
export default {"aucStatus":"styles_aucStatus__lm-f2","lotStatus":"styles_lotStatus__UA-pW"};